import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrincipalComponent } from './principal/principal.component';
import { RappelsComponent } from './principal/rappels/rappels.component';
import { TracarticlesComponent } from './principal/tracarticles/tracarticles.component';
import { GestionclientsComponent } from './principal/gestionclients/gestionclients.component';

const routes: Routes = [ 
  { path: '', component: PrincipalComponent,
    children: [
      { path: 'gestionclients', component: GestionclientsComponent },
      { path: 'rappels', component: RappelsComponent },
      { path: 'tracarticles', component: TracarticlesComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
